"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostAddressMatchPropertiesAddressMatchPostRequest$ = exports.PostAddressMatchPropertiesAddressMatchPostRequest$outboundSchema = exports.PostAddressMatchPropertiesAddressMatchPostRequest$inboundSchema = exports.FieldsProperty$ = exports.FieldsProperty$outboundSchema = exports.FieldsProperty$inboundSchema = exports.PostAddressMatchPropertiesAddressMatchPostSecurity$ = exports.PostAddressMatchPropertiesAddressMatchPostSecurity$outboundSchema = exports.PostAddressMatchPropertiesAddressMatchPostSecurity$inboundSchema = void 0;
exports.postAddressMatchPropertiesAddressMatchPostSecurityToJSON = postAddressMatchPropertiesAddressMatchPostSecurityToJSON;
exports.postAddressMatchPropertiesAddressMatchPostSecurityFromJSON = postAddressMatchPropertiesAddressMatchPostSecurityFromJSON;
exports.fieldsPropertyToJSON = fieldsPropertyToJSON;
exports.fieldsPropertyFromJSON = fieldsPropertyFromJSON;
exports.postAddressMatchPropertiesAddressMatchPostRequestToJSON = postAddressMatchPropertiesAddressMatchPostRequestToJSON;
exports.postAddressMatchPropertiesAddressMatchPostRequestFromJSON = postAddressMatchPropertiesAddressMatchPostRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const shared = __importStar(require("../shared/index.js"));
/** @internal */
exports.PostAddressMatchPropertiesAddressMatchPostSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.PostAddressMatchPropertiesAddressMatchPostSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PostAddressMatchPropertiesAddressMatchPostSecurity$;
(function (PostAddressMatchPropertiesAddressMatchPostSecurity$) {
    /** @deprecated use `PostAddressMatchPropertiesAddressMatchPostSecurity$inboundSchema` instead. */
    PostAddressMatchPropertiesAddressMatchPostSecurity$.inboundSchema = exports.PostAddressMatchPropertiesAddressMatchPostSecurity$inboundSchema;
    /** @deprecated use `PostAddressMatchPropertiesAddressMatchPostSecurity$outboundSchema` instead. */
    PostAddressMatchPropertiesAddressMatchPostSecurity$.outboundSchema = exports.PostAddressMatchPropertiesAddressMatchPostSecurity$outboundSchema;
})(PostAddressMatchPropertiesAddressMatchPostSecurity$ || (exports.PostAddressMatchPropertiesAddressMatchPostSecurity$ = PostAddressMatchPropertiesAddressMatchPostSecurity$ = {}));
function postAddressMatchPropertiesAddressMatchPostSecurityToJSON(postAddressMatchPropertiesAddressMatchPostSecurity) {
    return JSON.stringify(exports.PostAddressMatchPropertiesAddressMatchPostSecurity$outboundSchema.parse(postAddressMatchPropertiesAddressMatchPostSecurity));
}
function postAddressMatchPropertiesAddressMatchPostSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PostAddressMatchPropertiesAddressMatchPostSecurity$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PostAddressMatchPropertiesAddressMatchPostSecurity' from JSON`);
}
/** @internal */
exports.FieldsProperty$inboundSchema = z.union([
    shared.MultiplePropertyUserFields$inboundSchema,
    shared.PropertyUserFields$inboundSchema,
]);
/** @internal */
exports.FieldsProperty$outboundSchema = z.union([
    shared.MultiplePropertyUserFields$outboundSchema,
    shared.PropertyUserFields$outboundSchema,
]);
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var FieldsProperty$;
(function (FieldsProperty$) {
    /** @deprecated use `FieldsProperty$inboundSchema` instead. */
    FieldsProperty$.inboundSchema = exports.FieldsProperty$inboundSchema;
    /** @deprecated use `FieldsProperty$outboundSchema` instead. */
    FieldsProperty$.outboundSchema = exports.FieldsProperty$outboundSchema;
})(FieldsProperty$ || (exports.FieldsProperty$ = FieldsProperty$ = {}));
function fieldsPropertyToJSON(fieldsProperty) {
    return JSON.stringify(exports.FieldsProperty$outboundSchema.parse(fieldsProperty));
}
function fieldsPropertyFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.FieldsProperty$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'FieldsProperty' from JSON`);
}
/** @internal */
exports.PostAddressMatchPropertiesAddressMatchPostRequest$inboundSchema = z.object({
    AddressMatchPostRequest: shared.AddressMatchPostRequest$inboundSchema,
    confidence: z.number().default(0.7),
    "fields[property]": z.array(z.union([
        shared.MultiplePropertyUserFields$inboundSchema,
        shared.PropertyUserFields$inboundSchema,
    ])),
    format: shared.AddressMatchFormats$inboundSchema.optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "AddressMatchPostRequest": "addressMatchPostRequest",
        "fields[property]": "fieldsProperty",
    });
});
/** @internal */
exports.PostAddressMatchPropertiesAddressMatchPostRequest$outboundSchema = z.object({
    addressMatchPostRequest: shared.AddressMatchPostRequest$outboundSchema,
    confidence: z.number().default(0.7),
    fieldsProperty: z.array(z.union([
        shared.MultiplePropertyUserFields$outboundSchema,
        shared.PropertyUserFields$outboundSchema,
    ])),
    format: shared.AddressMatchFormats$outboundSchema.optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        addressMatchPostRequest: "AddressMatchPostRequest",
        fieldsProperty: "fields[property]",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PostAddressMatchPropertiesAddressMatchPostRequest$;
(function (PostAddressMatchPropertiesAddressMatchPostRequest$) {
    /** @deprecated use `PostAddressMatchPropertiesAddressMatchPostRequest$inboundSchema` instead. */
    PostAddressMatchPropertiesAddressMatchPostRequest$.inboundSchema = exports.PostAddressMatchPropertiesAddressMatchPostRequest$inboundSchema;
    /** @deprecated use `PostAddressMatchPropertiesAddressMatchPostRequest$outboundSchema` instead. */
    PostAddressMatchPropertiesAddressMatchPostRequest$.outboundSchema = exports.PostAddressMatchPropertiesAddressMatchPostRequest$outboundSchema;
})(PostAddressMatchPropertiesAddressMatchPostRequest$ || (exports.PostAddressMatchPropertiesAddressMatchPostRequest$ = PostAddressMatchPropertiesAddressMatchPostRequest$ = {}));
function postAddressMatchPropertiesAddressMatchPostRequestToJSON(postAddressMatchPropertiesAddressMatchPostRequest) {
    return JSON.stringify(exports.PostAddressMatchPropertiesAddressMatchPostRequest$outboundSchema.parse(postAddressMatchPropertiesAddressMatchPostRequest));
}
function postAddressMatchPropertiesAddressMatchPostRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PostAddressMatchPropertiesAddressMatchPostRequest$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PostAddressMatchPropertiesAddressMatchPostRequest' from JSON`);
}
//# sourceMappingURL=postaddressmatchpropertiesaddressmatchpost.js.map